import React from 'react';
import Card from "../Card";

const Deck = React.memo(function ({offeredCard, isVisible}) {
    return <div className='deck'>
        {
            [1, 2, 3].map((item, index) => {
                return <Card
                    key={index}
                    className={`deck-${item}`}/>
            })
        }
        <Card
            data={offeredCard}
            className={` 
                card opened-card deck-4           
                ${offeredCard ? `card-name_${offeredCard?.suit}${offeredCard?.rank?.name}` : ''}
                ${isVisible ? 'card-visible' : ''}
            `}
        />
    </div>
})

export default Deck
